import {createSlice} from "@reduxjs/toolkit";
import {clearDeliveryPageDispatch} from "../dispatch/delivery/clear-delivery-page";
import {clearSelectedDeliveryDispatch} from "../dispatch/delivery/clear-selected-delivery";
import {addControlDeliveriesDispatch} from "../dispatch/delivery/control-deliveries/add-control-deliveries";
import {addControlDeliveryDispatch} from "../dispatch/delivery/control-deliveries/add-control-delivery";
import {clearControlDeliveriesDispatch} from "../dispatch/delivery/control-deliveries/clear-control-deliveries";
import {initControlDeliveriesDispatch} from "../dispatch/delivery/control-deliveries/init-control-deliveries";
import {
    removeControlDeliveriesByIdsDispatch
} from "../dispatch/delivery/control-deliveries/remove-control-deliveries-by-ids";
import {removeControlDeliveryByIdDispatch} from "../dispatch/delivery/control-deliveries/remove-control-delivery-by-id";
import {setControlDeliveriesDispatch} from "../dispatch/delivery/control-deliveries/set-control-deliveries";
import {clearDisplayDeliveriesDispatch} from "../dispatch/delivery/display-deliveries/clear-display-deliveries";
import {setDisplayDeliveriesDispatch} from "../dispatch/delivery/display-deliveries/set-display-deliveries";
import {
    clearSelectedDisplayDeliveryIdDispatch
} from "../dispatch/delivery/selected-display-delivery-id/clear-selected-display-delivery-id";
import {
    setSelectedDisplayDeliveryIdDispatch
} from "../dispatch/delivery/selected-display-delivery-id/set-selected-display-delivery-id";
import {setDeliveryPageDispatch} from "../dispatch/delivery/set-delivery-page";
import {setDeliveryPageByDtoDispatch} from "../dispatch/delivery/set-delivery-page-by-dto";
import {setRecentLocationByDeliveryDispatch} from "../dispatch/delivery/set-recent-location-by-delivery";
import {setSelectedDeliveryDispatch} from "../dispatch/delivery/set-selected-delivery";
import {RootState} from "../store";
import {DeliveryState} from "../type/delivery-state";
import {addCachedDeliveriesDispatch} from "../dispatch/delivery/cached-deliveries/add-cached-deliveries";
import {clearCachedDeliveriesDispatch} from "../dispatch/delivery/cached-deliveries/clear-cached-deliveries";

const initialState: DeliveryState = {
    selectedDelivery: undefined,
    deliveryPage: {
        contents: [],
        first: true,
        last: true,
        page: 0,
        totalPages: 1,
        totalElements: 0,
    },
    recentLocationByDelivery: {
        totalElements: 0,
        contents: [],
    },
    displayDeliveries: [],
    selectedDisplayDeliveryId: undefined,
    controlDeliveries: [],
    status: "idle",
    cachedUpdateDeliveries: [],
};

export const deliverySlice = createSlice({
    name: "deliverySlice",
    initialState,
    reducers: {
        setDeliveryPageByDtoAction: setDeliveryPageByDtoDispatch,
        clearSelectedDeliveryAction: clearSelectedDeliveryDispatch,
        initControlDeliveriesAction: initControlDeliveriesDispatch,
        setSelectedDeliveryAction: setSelectedDeliveryDispatch,
        setDeliveryPageAction: setDeliveryPageDispatch,
        clearDeliveryPageAction: clearDeliveryPageDispatch,
        setRecentLocationByDeliveryAction: setRecentLocationByDeliveryDispatch,
        setDisplayDeliveriesAction: setDisplayDeliveriesDispatch,
        clearDisplayDeliveriesAction: clearDisplayDeliveriesDispatch,
        setSelectedDisplayDeliveryIdAction: setSelectedDisplayDeliveryIdDispatch,
        clearSelectedDisplayDeliveryIdAction:
        clearSelectedDisplayDeliveryIdDispatch,
        setControlDeliveriesAction: setControlDeliveriesDispatch,
        addControlDeliveryAction: addControlDeliveryDispatch,
        addControlDeliveriesAction: addControlDeliveriesDispatch,
        removeControlDeliveryByIdAction: removeControlDeliveryByIdDispatch,
        removeControlDeliveriesByIdsAction: removeControlDeliveriesByIdsDispatch,
        clearControlDeliveriesAction: clearControlDeliveriesDispatch,

        addCachedUpdateDeliveries: addCachedDeliveriesDispatch,
        clearCachedUpdateDeliveries: clearCachedDeliveriesDispatch,
    },
});

export const {
    setDeliveryPageByDtoAction,
    clearSelectedDeliveryAction,
    initControlDeliveriesAction,
    setSelectedDeliveryAction,
    setDeliveryPageAction,
    clearDeliveryPageAction,
    setRecentLocationByDeliveryAction,
    setDisplayDeliveriesAction,
    clearDisplayDeliveriesAction,
    setSelectedDisplayDeliveryIdAction,
    clearSelectedDisplayDeliveryIdAction,
    setControlDeliveriesAction,
    addControlDeliveryAction,
    addControlDeliveriesAction,
    removeControlDeliveryByIdAction,
    removeControlDeliveriesByIdsAction,
    clearControlDeliveriesAction,
    addCachedUpdateDeliveries,
    clearCachedUpdateDeliveries,
} = deliverySlice.actions;

export const deliveryState = (state: RootState) => state.delivery;

export default deliverySlice.reducer;
